import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Futebol Americano",
    Baseball: "Beisebol",
    Basketball: "Basquete",
    Boxing: "Boxe",
    Chess: "Xadrez",
    Cricket: "Cricket",
    Darts: "Dardos",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Futebol",
    "Formula 1": "Fórmula 1",
    "Gaelic Football": "Futebol Gaélico",
    "Generic Sport": "Generic Sport",
    Golf: "Golfe",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Handebol",
    "Ice Hockey": "Hóquei no Gelo",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Liga de Rugby",
    "Rugby Union": "Rugby Union",
    Snooker: "Sinuca internacional",
    "Table Tennis": "Tênis de mesa",
    Tennis: "Tênis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} vitória",
    WinFirstRound: "{name} vencer o primeiro round",
    FirstTouchdown: "{name} marcar o primeiro touchdown",
    FirstTry: "{name} marcar o primeiro ensaio",
    TotalGoals: "{name} Total de gols",
    TotalRuns: "{name} Total de Runs",
    TotalPoints: "{name} Total de pontos",
    TopBatsman: "{name} Melhor Batsman",
    TopBowler: "{name} Melhor Bowler",
    FirstScore: "{name} marcar primeiro"
  },
  PromoTexts: {
    Pick: "Faça a suas escolhas",
    Bet: "Apostar",
    Pays: "Levantamento"
  },
  DateTimeTexts: {
    Today: "Hoje",
    Tomorrow: "Amanhã",
    Live: "Vivo"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Faça a suas escolhas",
    Return: "Levantamento",
    Stake: "Apostar",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Gols marcados",
    shots: "Chutes",
    shots_on_target: "Chute a gol",
    ball_possession: "Posse de bola",
    goals_conceded: "Gols concedidos",
    "Per match": "Por jogo",
    H2H: "Confronto",
    W: "V",
    D: "E",
    L: "D",
    T: "E",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
